import { Checkbox } from 'antd'
import { useEffect, useState } from 'react'

export default BooleanInput = ({ initialValue, save, props... }) ->
  [value, setValue] = useState(if initialValue? then initialValue else false)

  useEffect( ->
    # force onChange for default `false` value
    props.checked ?= false
    props.onChange({ target: { checked: props.checked }})
    undefined
  , [])

  <Checkbox
    defaultChecked={value}
    {props...}
  ></Checkbox>
